import { createFileRoute } from '@tanstack/react-router';
import { CaptureSettingsPage } from '@/pages/super-admin/record-and-send/capture-settings-page';

export const Route = createFileRoute('/_authenticated/super-admin/record-and-send')({
	component: CaptureSettingsPage,
});
